<template>
  <footer class="ft-content space-up">
    <div class="container">
      <div class="row">
        <div class="col-12 footer-text">   
          <span class="text-red">การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป</span>
        </div>
        <div class="col-12 contact">
          <i class="feather-icon icon-phone"></i>
          <span>02-111-1111, 02-111-9999</span>
          <div class="vertical-line"></div>
          <span>KTB Call Center</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 footer-text">         
          <p class="long-paragraph">เว็บไซต์นี้แสดงผลได้ดีบนเบราเซอร์ Chome Firefox Safari และ Internet Explorer เวอร์ชั่น 11 ขึ้นไป</p>
          <p class="long-paragraph">สงวนสิทธิ์ พ.ศ. 2561 บมจ. ธนาคารกรุงไทย</p>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
  export default {
    name: 'appFooter',
  }
</script>
